// extracted by mini-css-extract-plugin
export default {"header":"_72bdebb5","title":"_39dd888a","itemStatus":"_4835b26b","statusContainer":"_e2182d59","iconContainer":"_8b3c3dc6","icon":"_8dde21"};